import React from "react";
import styles from "./md-icon.scss";
export default function Undo20(props) {
    return (
        <div className={styles.view + " " + styles.size20}>
            <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.708 15.833H5.854v-1.75h5.854c.861 0 1.611-.264 2.25-.791.64-.528.959-1.202.959-2.021 0-.82-.32-1.496-.959-2.031-.639-.535-1.389-.802-2.25-.802H6.667l2.125 2.124-1.23 1.23-4.229-4.23 4.229-4.229 1.23 1.229-2.125 2.126h5.041c1.347 0 2.51.434 3.49 1.302.98.868 1.469 1.955 1.469 3.26 0 1.305-.49 2.396-1.469 3.271-.98.875-2.143 1.312-3.49 1.312Z" fill={props.color || "#FFFFFF"} /></svg>
        </div>
    );
};

